import React from "react";
import {
	StyleSheet,
	View,
	ActivityIndicator
} from "react-native";

import Style from "ae-style";

var styles = StyleSheet.create({
	loader: {
		alignItems: "center",
	}
});

export default function Indicator(props){

	var contrast = props.contrast;
	var color = contrast ? Style.look.contrast.text : Style.look.text;

	return (
		<View style={styles.loader}>
			<ActivityIndicator accessibilityLabel="Bluetooth Device Scanning Indicator" animating size={"large"} color={color} />
		</View>
	);
}
